module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-8b24a2c0eb9c37a8ba7248cef68d919a.webp";